import React from 'react';
import { BookOpenIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, pricing } from '../data/landing';
type PriceCardProps = {
  subtitle: string;
  idealFor?: string;
  ctaLabel: string;
};
export function PriceCard({
  subtitle,
  idealFor,
  ctaLabel
}: PriceCardProps) {
  return <div className="relative mx-auto w-full max-w-2xl rounded-[2rem] border-2 border-brand bg-white p-7 text-center shadow-[0_24px_60px_-30px_rgba(20,83,45,0.45)] md:p-10" data-id="element-29" data-mp="28s939bdwud1k">
      <span className="absolute -top-4 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full bg-brand px-4 py-1.5 text-xs font-black uppercase tracking-wider text-white" data-id="element-30" data-mp="31gofxr9kkj9q">
        Precio de lanzamiento
      </span>
      <BookOpenIcon className="mx-auto h-9 w-9 text-brand" aria-hidden="true" data-id="element-31" data-mp="2rgxmlswqwab8" />
      <h3 className="mt-3 text-2xl font-black uppercase leading-tight text-brand md:text-3xl" data-id="element-32" data-mp="1b37f0c6f33wu">
        MegaPack Colon Tranquilo
      </h3>
      <p className="mt-2 text-base font-semibold text-charcoal md:text-lg" data-id="element-33" data-mp="1g4d9aefq6z8h">{subtitle}</p>
      {idealFor && <p className="mt-3 text-sm text-muted" data-id="element-34" data-mp="3kmclxc6niftr">
          <span className="font-bold text-charcoal" data-id="element-35" data-mp="3fnjd3x2b7czx">Ideal para:</span> {idealFor}
        </p>}
      <div className="mt-6 flex flex-col items-center" data-id="element-36" data-mp="3tnal9h659z60">
        <span className="text-xl font-semibold text-muted line-through decoration-danger decoration-2" data-id="element-37" data-mp="3tkoc5d3lvblo">
          {pricing.original}
        </span>
        <span className="mt-2 flex items-baseline gap-2 rounded-2xl bg-gold-soft px-5 py-2" data-id="element-38" data-mp="7ere2klcauli">
          <span className="text-6xl font-black tracking-tight text-brand md:text-7xl" data-id="element-39" data-mp="2h9f9n11dvr8">
            {pricing.current}
          </span>
          <span className="text-lg font-bold text-charcoal" data-id="element-40" data-mp="g7cy040pj7bx">{pricing.currency}</span>
        </span>
      </div>
      <div className="mt-7 flex justify-center" data-id="element-41" data-mp="c72o4g9snwrs">
        <CtaButton href={checkoutUrl} data-id="element-42" data-mp="q5ita2s0df7t">{ctaLabel}</CtaButton>
      </div>
    </div>;
}